/* Ask: chat, search, research and agents in one screen, with mode, model and effort chosen automatically
   (pin any of them from the Options label above the box). The screens it hosts keep their own folders
   (features/chat, features/search, features/agents) as hidden features that only redirect old addresses here. */
import { lazy } from 'react';
import { MessageSquare } from 'lucide-react';
import { defineFeature } from '../../app/feature';
import { useApprovalCount } from '../agents/store';

export default defineFeature({
  id: 'ask',
  title: 'Ask',
  short: 'Ask',
  icon: MessageSquare,
  group: 'Work',
  route: '/ask',
  order: 1,
  rail: true,
  bottom: true,
  screen: lazy(() => import('./Screen.tsx')),
  badge: () => useApprovalCount.getState().count || undefined,
  commands: [
    // Chat
    { id: 'new', title: 'New chat', to: '/ask', keywords: ['start', 'conversation', 'ask', 'question'] },
    { id: 'history', title: 'Search chats', to: '/ask?tab=history', keywords: ['history', 'find', 'archive', 'folders'] },
    { id: 'temp', title: 'New temporary chat', to: '/ask?temporary=1', keywords: ['incognito', 'private', 'not saved'] },
    { id: 'compare', title: 'Compare models', to: '/ask?tab=compare', keywords: ['council', 'heavy', 'side by side'] },
    // Search and research
    { id: 'search', title: 'New search', to: '/ask/search', keywords: ['web', 'answer', 'citations', 'perplexity'] },
    { id: 'deep', title: 'Start deep research', to: '/ask/search?mode=deep', keywords: ['report', 'research', 'sources'] },
    { id: 'wide', title: 'Start wide research', to: '/ask/search?tab=wide&mode=wide', keywords: ['batch', 'table', 'items', 'list'] },
    { id: 'running', title: 'Research running now', to: '/ask/search?tab=running', keywords: ['progress', 'pause', 'stop'] },
    { id: 'scope', title: 'Search scope and presets', to: '/ask/search?tab=modes', keywords: ['sources', 'sites', 'academic', 'read page', 'url'] },
    { id: 'live', title: 'Live cards', to: '/ask/search?tab=live', keywords: ['weather', 'stock', 'flight', 'score', 'package', 'currency'] },
    { id: 'discover', title: 'Discover', to: '/ask/search?tab=discover', keywords: ['news', 'feed', 'topics'] },
    // Agents
    { id: 'task', title: 'New agent task', to: '/ask/agents?new=1', keywords: ['agent', 'task', 'plan', 'goal'] },
    { id: 'approvals', title: 'Review agent approvals', to: '/ask/agents?approvals=1', keywords: ['approve', 'deny', 'pending'] },
    { id: 'kill', title: 'Stop all agents (kill switch)', to: '/ask/agents?kill=1', keywords: ['stop', 'kill', 'emergency'] },
    { id: 'automations', title: 'Automations and schedules', to: '/ask/agents/automations', keywords: ['schedule', 'cron', 'trigger', 'workflow'] },
    { id: 'always-on', title: 'Always-on agents', to: '/ask/agents/always-on', keywords: ['teammate', 'background'] },
    { id: 'calls', title: 'Phone calls and chat channels', to: '/ask/agents/calls', keywords: ['phone', 'call', 'whatsapp', 'slack', 'email'] },
    { id: 'browser', title: 'Agent browser and desktop', to: '/ask/agents/browser', keywords: ['browser', 'extension', 'desktop', 'computer'] },
    { id: 'agent-settings', title: 'Agent settings', to: '/ask/agents?settings=1', keywords: ['permissions', 'proactivity'] },
  ],
  capabilities: ['CHAT-07'],
});
